import { Component } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { getSystemTypeDescriptionByValue, SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { PlanService } from '../crud-service';
import { PlanCrudIndex } from './crud-index';
import moment from 'moment';
import { SystemIndexSelectComponent } from '../../systems/crud-index/crud-index-select.component';
import { PlanPermissionService } from '../../plan-permissions/crud-service';

@Component({
  selector: 'app-plan-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [PlanService, PlanPermissionService],
})
export class PlanIndexComponent extends PlanCrudIndex {
  ngOnInit(): void { }

  override filterFields: IFieldConfig[] = [
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Parceiro',
      name: 'partner',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT_CRUD,
      label: 'Sistema',
      component: SystemIndexSelectComponent,
      name: 'system',
      value: 'name',
      defaultValue: ' ',
      options: [Object.values([])],
      placeholder: 'Selecione uma opção',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Valor mensal',
      name: 'monthlyValue',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT,
      label: 'Data de Vencimento',
      name: 'dueDate',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.INPUT_DATE,
      label: 'Data de Criação',
      name: 'createdAt',
      value: '',
    },
    {
      type: TypeComponentFieldEnum.SELECT,
      label: 'TIPO',
      name: 'type',
      options: Object.values(SystemTypeEnum),
      placeholder: 'Selecione uma opção',
      validation: [Validators.required],
    },

    {
      type: TypeComponentFieldEnum.SLIDE_TOGGLE,
      label: 'Ativo',
      name: 'isActive',
      value: true,
    }
  ];

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);

    // Salvar o filtro aplicado para combinação com pesquisa geral
    this.lastAppliedFilter = filterForm.value;
    this.isAdvancedFilterActive = true;

    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        const allItems = data.map((item: any) => {
          item['image'] = item.system?.image;
          item['partners'] = this.getPartnersLabel(item.partners);
          item['isActive'] = item.isActive;
          item['type'] = getSystemTypeDescriptionByValue(item.type);
          item['dueDate'] = item.system?.dueDate;
          item['system'] = item.system?.name;
          item['createdAt'] = item.createdAt;
          item['hideEdit'] = !item.allowEdit;
          item['hideDelete'] = !item.allowDelete;
          item['hasAudit'] = item.audits?.length > 0;
          return this.mapBackendDataToDisplay(item);
        });

        this.dataSource = new MatTableDataSource<any>(allItems);

        if (this.dataSource.paginator) {
          this.dataSource.paginator.length = this.length;
        }
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.name) params.name = filter.name.trim().toUpperCase();

    if (filter.type) {
      params.type = this.mapTypeToBackendValue(filter.type);
    }

    if (filter.partner) {
      params.partner = filter.partner.trim().toUpperCase();
    }

    if (filter.system) {
      params.systemName = filter.system.name
    }

    if (filter.dueDate) {
      params.dueDate = filter.dueDate
    }

    if (filter.createdAt) {
      params.createdAt = filter.createdAt
    }

    if (filter.monthlyValue) {
      params.monthlyValue = filter.monthlyValue
    }


    if (filter.isActive !== null && filter.isActive !== undefined) {
      params.isActive = filter.isActive;
    }

    return params;
  }

  private mapTypeToBackendValue(type: SystemTypeEnum): string | undefined {
    switch (type) {
      case SystemTypeEnum.APPLICATION:
        return SystemTypeIdEnum[SystemTypeEnum.APPLICATION] as unknown as string;
      case SystemTypeEnum.SYSTEM:
        return SystemTypeIdEnum[SystemTypeEnum.SYSTEM] as unknown as string;
      default:
        return undefined;
    }
  }

  private mapBackendDataToDisplay(item: any): any {
    if (item.type) {
      if (item.type === SystemTypeIdEnum[SystemTypeEnum.APPLICATION]) {
        item.type = SystemTypeEnum.APPLICATION;
      } else if (item.type === SystemTypeIdEnum[SystemTypeEnum.SYSTEM]) {
        item.type = SystemTypeEnum.SYSTEM;
      }
    }

    return item;
  }

  override filter(event: any) {
    this.params.filter = event;

    // Se há filtros avançados ativos, combinar com pesquisa geral
    if (this.isAdvancedFilterActive && this.lastAppliedFilter) {
      const combinedFilters = this.getFilters(this.lastAppliedFilter);
      // Adicionar pesquisa geral aos filtros avançados
      if (event && event.trim()) {
        combinedFilters.name = event.trim().toUpperCase();
      }

      // Criar um FormGroup mock para manter compatibilidade
      const mockFormGroup = {
        value: combinedFilters
      } as FormGroup;

      this.submitAdvancedFilter(mockFormGroup);
    } else {
      this.loadList();
    }
  }
}